import { useTranslation } from 'react-i18next';

import Hello from '../../../../../../../../public/gifs/hello.gif';
import Clap from '../../../../../../../../public/gifs/clapping.gif';
import Thumbsup from '../../../../../../../../public/gifs/Thumbsup.gif';
import Victory from '../../../../../../../../public/gifs/victory.gif';
import Waving from '../../../../../../../../public/gifs/waving.gif';
import Twist from '../../../../../../../../public/gifs/twist.gif';
import { REACTIONS } from '../../../../../../../../constants/reactions';
import { IReaction } from '../interfaces';

export const useReactions = () => {
  const { t: translate } = useTranslation('common');
  const reactions: IReaction[] = [];

  for (let i = 0; i < REACTIONS.length; i++) {
    switch (REACTIONS[i]) {
      case 'waving':
        reactions.push({
          previewImage: Hello,
          id: 'waving',
          title: translate('actions.hello'),
        });
        break;
      case 'clap':
        reactions.push({
          previewImage: Clap,
          id: 'clap',
          title: translate('actions.clap'),
        });
        break;
      case 'waving2':
        reactions.push({
          previewImage: Waving,
          id: 'waving2',
          title: translate('actions.waving'),
        });
        break;
      case 'cooldance':
        reactions.push({
          previewImage: Twist,
          id: 'cooldance',
          title: translate('actions.dance'),
        });
        break;
      case 'agreeing':
        reactions.push({
          previewImage: Thumbsup,
          id: 'agreeing',
          title: translate('actions.agree'),
        });
        break;
      case 'victory':
        reactions.push({
          previewImage: Victory,
          id: 'victory',
          title: translate('actions.victory'),
        });
        break;
    }
  }

  return reactions;
};
